import { makeApiCall } from "../makeApiCall";
import { AdminService_URL } from "../Url";

export const LogisticDashActions = {
  LOGISTIC_DASHBOARD_SUCCESS: "LOGISTIC_DASHBOARD_SUCCESS",
  LOGISTIC_DASHBOARD_FAILURE: "LOGISTIC_DASHBOARD_FAILURE",
};

////? Checker dashboard Service

export function logisticDashboardSuccessAction(props) {
  return (dispatch) => {
    dispatch({
      type: LogisticDashActions.LOGISTIC_DASHBOARD_SUCCESS,
      payload: props,
    });
  };
}

export function logisticDashboardFailureAction(error) {
  return {
    type: LogisticDashActions.LOGISTIC_DASHBOARD_FAILURE,
    payload: error,
  };
}

export function logisticDashboardThunk(props, warehouseIds) {
  const reqHeader = {
    transactionId: "a",
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const postUrl = `${AdminService_URL}/fetchDeliveryDashboard?fromDate=${
    props.fromDate
  }&toDate=${props.toDate}${
    props.isExportCsv === true ? "&isExportCsv=true" : ""
  }`;

  // const postUrl = `https://9eb9c7ae-5439-4234-a41a-425491d0bc47.mock.pstmn.io/fetchDeliveryDashboard?fromDate=${
  //   props.fromDate
  // }&toDate=${props.toDate}${
  //   props.isExportCsv === true ? "&isExportCsv=true" : ""
  // }`;
  return makeApiCall(
    postUrl,
    logisticDashboardSuccessAction,
    logisticDashboardFailureAction,
    "POST",
    warehouseIds,
    reqHeader,
    props.history
  );
}
